import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useIsNexaDashboard = (): boolean => {
  const location = useLocation();

  return useMemo(() => {
    const url = location.pathname;
    return url.includes('nexa') || url.includes('/nx/share');
  }, [location.pathname]);
};

export default useIsNexaDashboard;
